<script setup>
import { ref } from 'vue';

const QUICK_EMOJIS = ['👍', '❤️', '😂', '😮', '😢', '🙏'];

const props = defineProps({
  busy: { type: Boolean, default: false },
});
const emit = defineEmits(['pick', 'pickMore']);

const open = ref(false);
function toggle() { open.value = !open.value; }
function pick(emoji) {
  if (props.busy) return;
  emit('pick', emoji);
  open.value = false;
}
</script>

<template>
  <div class="sz-reaction-picker inline-flex items-center gap-1 rounded-full px-1.5 py-1 shadow-md">
    <button
      v-for="e in QUICK_EMOJIS"
      :key="e"
      type="button"
      class="sz-rp-btn"
      :disabled="busy"
      :aria-label="`Reagir com ${e}`"
      @click.stop="pick(e)"
    >
      <span>{{ e }}</span>
    </button>
  </div>
</template>

<style lang="scss">
.sz-reaction-picker {
  background: var(--color-background, #fff);
  border: 1px solid rgba(127,127,127,0.2);
  backdrop-filter: blur(6px);
  gap: 2px;
}
.sz-rp-btn {
  width: 26px; height: 26px; border: 0; background: transparent; border-radius: 50%;
  cursor: pointer; font-size: 16px; line-height: 1; padding: 0;
  display: inline-flex; align-items: center; justify-content: center;
  transition: transform 0.12s ease, background 0.12s ease;
}
.sz-rp-btn:hover:not(:disabled) { transform: scale(1.2); background: rgba(127,127,127,0.1); }
.sz-rp-btn:disabled { opacity: 0.5; cursor: not-allowed; }
.dark .sz-reaction-picker {
  background: #27272a;
  border-color: rgba(255, 255, 255, 0.12);
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.35);
}
.dark .sz-rp-btn:hover:not(:disabled) {
  background: rgba(255, 255, 255, 0.08);
}
</style>
